<template>
    <div>
        <!-- <div class="tabsFather">
            <div v-for="(item,index) in tabsData" :class="[tabsIndex == item.index ? 'tabsActive' : '','tabsClass']"  @click="tabsClick(item)">{{ item.title }}</div>
        </div> -->
        <div class="line999"></div>
        <template v-if="tabsIndex == '10'">
            <div class="commonFather">
                <div class="commonList" v-for="(item,index) in tabsData" :key="index"  @click="tabsClick(index)">
                    <div class="commonListLeft">{{ item.title }}</div>
                    <div class="commonListRight">{{ item.date }}</div>
                </div>
            </div>
        
            <div class="line999"></div>
            <div class="mob-line"></div>
            <!-- <van-pagination v-model="currentPage" :total-items="1" :items-per-page="5" /> -->
            
        </template>
       
        <template>
            <!-- <div class="tabs1Title">大事记</div> -->
            <div class="tabs1">
                
                <div class="commonFather">
                    <div class="commonList" v-for="(item,index) in tabsData" :key="index"  @click="goDetails(item)">
                        <div class="commonListLeft">{{ item.title }}</div>
                        <div class="commonListRight">{{ item.date }}</div>
                    </div>
                </div>
                <div class="pageClass">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="1">
                    </el-pagination>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        name: "mobIntroduce",
        data(){
            return{
                tabsData:[
                    {title:"充电桩生产及销售业务",index:'4-1',date:"2020-12-17",type:'2',id:"1"},
                    {title:"充电桩建设及运营业务",index:'4-2',date:"2020-12-17",type:'1',id:"2"},
                    {title:"传感光伏业务",index:'4-3',date:"2021-10-17",type:'1',id:"3"},
                    {title:"BIPV(光伏业务)",index:'4-4',date:"2021-10-17",type:'1',id:"4"},
                    {title:"共享出行分时租赁",index:'4-5',date:"2020-12-17",type:'1',id:"5"},
                    {title:"充电运营平台小程序解决方案",index:'4-6',date:"2020-12-17",type:'1',type:"6",id:"6"},
                ],
                currentPage:"1",
                tabsIndex:"3",
               
              
            }
        },
        methods:{
            tabsClick(e){
                console.log(e)
                this.tabsIndex = e.type
                console.log( this.tabsIndex)
                let listData = JSON.parse(JSON.stringify(this.listData))
                let listDataNew = listData.filter((item,index)=>{
                    if(item.type == e.type){
                        return item
                    }
                })
                this.listDataNew = listDataNew

            },
            goDetails(e){
                console.log(e)
                this.tabsIndex = e.type
                this.$router.push({path: "mobBusinessDetails",query:{data:e}});  
            },
        },
        created(){
            this.listDataNew = this.listData
            let type = this.$route.query.type
            if(type){
                this.tabsIndex = type
                let listData = JSON.parse(JSON.stringify(this.listData))
                let listDataNew = listData.filter((item,index)=>{
                    if(item.type == type){
                        return item
                    }
                })
                this.listDataNew = listDataNew
            }
        }
    }
</script>

<style scoped>
.pageClass{
    width: 100%;
    text-align: center;
}
.commonListRight{
    color: #999;
    font-size: 0.34rem;
}
.commonListLeft{
    font-size: 0.38rem;
    color: #000;
    width: 80%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.commonList{
    padding: 0.2rem;
    display: flex;
    justify-content: space-between;
}
.commonFather{
    background-color: #fff;
}
.detailClass{
    margin-top: 0px; 
    margin-bottom: 0px; 
    padding: 15px 0px 15px 65px; 
    border-width: 0px 0px 1px; 
    border-top-style: initial; 
    border-right-style: initial; 
    border-bottom-style: solid; 
    border-left-style: initial; 
    border-top-color: initial; 
    border-right-color: initial; 
    border-bottom-color: rgb(221, 221, 221); 
    border-left-color: initial; 
    border-image: initial; 
    font-size: 15px; 
    line-height: 28px;
}
.monClass{
    margin: 0px; 
    padding: 0px; 
    border: 0px; 
    width: 52px; 
    height: 28px; 
    display: block; 
    background-color: rgb(185, 185, 185); 
    text-align: center; 
    color: rgb(255, 255, 255); 
    font-size: 18px;
}
.ulClass{
    margin: 0px; 
    padding: 0px; 
    border: 0px; 
    /* width: 80%;  */
    /* float: right;  */
    position: relative;
}
.h2Class{
    /* margin: 0px 0px 0px; */
    margin-right: 50px;
    padding: 0px; 
    font-size: 18px !important; 
    width: 80px; 
    /* float: left;  */
    color: rgb(137, 137, 137); 
    line-height: 28px;
}
.tabs1Title{
    text-align: center;
    font-size: 0.45rem;
    font-weight: 600;
    padding-top: 0.4rem;
}
.tabs1{
    font-size: 0.35rem;
    padding: 0.2rem 0.01rem;
    /* line-height: 2rem; */
}
.tabsActive{
    color: #18D1BB !important;
}
.pageClass{
    width: 100%;
    text-align: center;
}
.mob-line{
    width: 100%;
    height: 0.08rem;
    background-color: #18D1BB;
    /* margin: 0.2rem 0; */
}
.commonListRight{
    color: #999;
    font-size: 0.34rem;
}
.commonListLeft{
    font-size: 0.38rem;
    color: #000;
}
.commonList{
    padding: 0.2rem;
    display: flex;
    justify-content: space-between;
}
.line999{
    width: 100%;
    height: 6px;
    background-color: #eee;
}
.commonFather{
    background-color: #fff;
}
.tabsClass{
   
    color: #333;
    font-size: 0.38rem;
    margin-right: 15px;
}
.tabsFather{
    display: flex;
    align-items: center;
    padding-left: 15px;
    height: 44px;
    line-height: 44px;
}
</style>